import * as ngCore from '@angular/core'

import type * as state from '../../../../../../state'
import * as entry from '../entry'

/** Renders one expandable File Finder group and its descendants. */
@ngCore.Component({
  imports: [entry.Component, ngCore.forwardRef(() => Component)],
  selector: 'atn-file-finder-group',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** Whether this group is expanded. */
  public readonly isExpandedSg = ngCore.signal(false)

  /** Group rendered by this component. */
  public readonly groupSg =
    ngCore.input.required<state.fileMgmt.models.FileTree.Group>({
      alias: 'group',
    })

  /** The group nesting level in the file tree. */
  public readonly depthSg = ngCore.input(0, {
    alias: 'depth',
  })

  /** Whether this is the final item in its parent group. */
  public readonly isLastSg = ngCore.input.required<boolean>({
    alias: 'isLast',
  })
}
